import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { useHistory, useParams } from "react-router";
import { Show } from "actions/SnackbarActions";
import { Post } from "utils/request";
import Formbody from "./Formbody";
import SweetAlert from "react-bootstrap-sweetalert";

const GroupsEdit = () => {

    const [loading, SetLoading] = useState(false);
    const [popup, SetPopup] = useState(false);
    const [popupMessage, SetPopupMessage] = useState("");

    const { group_id } = useParams();

    const dispatch = useDispatch();
    const history = useHistory();

    const Submit = async (data) => {
        if (!data?.name) {
            SetPopup(true);
            SetPopupMessage("Insira um nome!");
            return;
        }

        let form = new FormData();
        form.append("id", group_id);
        form.append("name", data?.name);
        form.append("description", data?.description);

        SetLoading(true);
        let response = await Post("groups/alter", form);
        SetLoading(false);
        
         
        dispatch(Show({
            show: true,
            message: response?.message,
            severity: response?.severity
        }));

        if (response?.status === true) history.push(`/groups/list`);
    }

    return (
        <div className="card">
            <SweetAlert
                warning
                show={popup}
                title="Atenção!"
                confirmBtnText="Ok"
                onConfirm={() => SetPopup(false)}
            >
                {popupMessage}
            </SweetAlert>
            <div className="card-body">
                <h2 className="title">Editar turma</h2>
                <p>Aqui são editados as turmas do sistema</p>
                <br/>
                <Formbody
                    OnConfirm={data => Submit(data)}
                    loading={loading}
                />
            </div>
        </div>
    );
}

export default GroupsEdit;